import styled from 'styled-components';

export const TextContent = styled('div')`
  max-width: 27.5em;
  width: 100%;
  padding: 0;
  margin: 0;
`;
